import Vue from 'vue'
import User from '@/classes/User'
import Claims from '@/classes/Claims'
import jwt_decode from 'jwt-decode'
import OrganizationalRole from '@/classes/OrganizationRole'

const state = {
  accessToken: '',
  appUser: new User(),
}

const getters = {
  getToken() {
    return state.accessToken
  },

  getUser() {
    return state.appUser
  },
}

const mutations = {}

const actions = {
  async signIn() {
    Vue.prototype.$auth.$watch('loading', async (loading) => {
      if (!loading && Vue.prototype.$auth.isAuthenticated) {
        state.accessToken = await Vue.prototype.$auth.getTokenSilently()

        const decodedToken: Claims = jwt_decode(state.accessToken)
        const claims = mapDecodedClaims(decodedToken)
        mapClaimsToSignedInUser(claims)

        // Assigns the boolean value if the user is authenticated or not.
        state.appUser.isLoggedIn = Vue.prototype.$auth.isAuthenticated
      } else {
        Vue.prototype.$auth.loginWithRedirect()
      }
    })
  },
  async logout() {
    Vue.prototype.$auth.logout({
      returnTo: process.env.VUE_APP_BASE_URL,
    })
  },
}

const mapDecodedClaims = (decodedToken: Claims): Claims => {
  const claims = new Claims(
    decodedToken['https://ctcsoftware.com/userId'],
    decodedToken['https://ctcsoftware.com/name'],
    decodedToken['https://ctcsoftware.com/email'],
    decodedToken['https://ctcsoftware.com/orgId'],
    decodedToken['https://ctcsoftware.com/orgName'],
    decodedToken['https://ctcsoftware.com/orgType'],
    decodedToken['https://ctcsoftware.com/roles'],
    decodedToken['https://ctcsoftware.com/groupIds']
  )

  return claims
}

const mapClaimsToSignedInUser = (claims: Claims): void => {
  state.appUser.id = claims.id
  state.appUser.email = claims.email
  state.appUser.displayName = claims.name
  state.appUser.organization!.id = claims.orgId
  state.appUser.organization!.type = claims.orgType

  for (const role of claims.roles) {
    state.appUser.roles.push(new OrganizationalRole('', role))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
